<template>
  <li class="fuel-funds__vendor-list--item">
    <span class="fuel-funds__vendor-list--percent">{{ vendor.percent }}%</span>
    <span class="fuel-funds__vendor-list--vendor">{{ vendor.vendor }}</span>
  </li>
</template>

<script>
  export default {
    name: 'FuelFundsVendor',
    props: ['vendor'],
  }
</script>
